import styled, { css } from 'styled-components';
import { mediaQuery } from 'styles/helper';

interface TableCellProps {
  backgroundColor?: string;
}

export const cellStyles = css<TableCellProps>`
  background-color: ${({ backgroundColor }) => backgroundColor || 'transparent'};
  padding: var(--spacing-3xl);
  border-right: 1px solid var(--border-secondary);
  box-sizing: border-box;

  button {
    width: fit-content;
  }

  ${mediaQuery(
    'md',
    css`
      width: 100%;
      display: grid;
      border-left: 1px solid var(--border-secondary);
    `
  )}

  ${mediaQuery(
    'sm',
    css`
      padding: var(--spacing-sm);
    `
  )}
`;

export const EmptyCell = styled.td<TableCellProps>`
  ${cellStyles}
  border: 0;

  ${mediaQuery(
    'md',
    css`
      display: none;
    `
  )}
`;

export const HeadCell = styled.th<TableCellProps>`
  ${cellStyles}

  align-items: flex-end;
  border-right: 0;
  border-left: 0;
  padding: 0 var(--spacing-3xl) var(--spacing-xl);
  display: flex;
  justify-content: center;

  ${mediaQuery(
    'md',
    css`
      border-left: 0;
      border-right: 1px solid var(--border-secondary);
      padding: var(--spacing-xl) var(--spacing-3xl);

      &:last-child {
        border-right: none;
      }

      .head-cell-text {
        font-size: var(--font-size-text-md);
      }
    `
  )}
`;

export const TitleCell = styled.td<TableCellProps>`
  ${cellStyles}

  vertical-align: baseline;

  ${mediaQuery(
    'md',
    css`
      width: 100%;
      border: 1px solid var(--border-secondary);
      vertical-align: unset;
    `
  )}

  ${mediaQuery(
    'sm',
    css`
      padding: var(--spacing-3xl);
    `
  )}
`;

export const ContentGrid = styled.span`
  display: grid;
  row-gap: var(--spacing-md);
  height: 100%;

  ${mediaQuery(
    'md',
    css`
      row-gap: var(--spacing-xs);
    `
  )}
`;

export const ContentCell = styled.td<TableCellProps>`
  ${cellStyles}
`;
